<template>
    <div class="ur-data-grid__content__row" :style="rowStyle" :class="rowClass"
         @mousedown="onRowClick" @mouseenter="setHover(true,$event)" @mouseleave="onMouseLeave($event)" @mouseup="onMouseUp($event)" @onmousemove="onMouseMove($event)"
            @dblclick="onDblClick">
        <!-- [CELL] Checkbox at first -->
        <checkbox-cell :value="row.__selected" v-if="isContCheck"/>
        <!-- [CELL] Contents cell -->
        <content-cell v-for="field in gridInfo.dataCols" :field="field" :value="row[field.value]" :key="field.value" ref="cells"/>
        <!-- [CELL] Accordion cell : Toggle Icon -->
        <accordion-cell :value="row.__accordion" @input="toggleAccordion" v-if="isAccord" :slide="slideAccordion"/>
    </div>
</template>


<script>
import checkboxCell  from '../cell/urDataGridContentCheckCell.vue';
import accordionCell from '../cell/urDataGridContentAccordionCell.vue';
import contentCell   from '../cell/urDataGridContentCell.vue';
import rowMixin from "./urDataGridContentRowMixin";

export default {
    name : 'urDataGridContentRow',
    mixins : [rowMixin], // @see for "row" props
    components : {contentCell, checkboxCell, accordionCell},
    inject : ['gridInfo'],
    props : {slideAccordion : Boolean},
    watch : {
        'row.__editMode':{handler(v,w) {
            // 1. Focus first cell
            // 1.1 Check first
            if(!v) return;
            if(!!this.gridInfo.vars_freezeWidth) return;
            // 1.2 Focus something
            this.focusFirst();
        }}
    },
    computed : {
        rowStyle() {
            var style = {}
            style['height']= this.gridInfo.opts.rowHeight+'px'
            // XXX +1px : 헤더를 바꾸니 자꾸 소숫점으로 뜨는데..그래서 얘도.. -ㄴ-
            style['width'] = (this.gridInfo.vars_tableWidth-this.gridInfo.vars_freezeWidth+1)+'px'
            style['min-width'] = `100%`
            return style
        },
        isContCheck() {return this.gridInfo.opts.selectCheck && !this.gridInfo.vars_freezeWidth},
        isAccord()    {return this.gridInfo.opts.accordion   && !this.gridInfo.vars_freezeWidth}
    },
}
</script>